var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5987",
    "data-name": "Group 5987",
    transform: "translate(-908 -387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 387)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "heart",
    transform: "translate(931.439 390.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7122",
    "data-name": "Path 7122",
    d: "M57.121,39.2A16.671,16.671,0,0,0,40.469,22.543,16.472,16.472,0,0,0,32.9,24.358a16.781,16.781,0,0,0-4.343,3.2,16.78,16.78,0,0,0-4.343-3.2,16.473,16.473,0,0,0-7.566-1.815A16.671,16.671,0,0,0,0,39.2c0,6.5,3.435,13.411,10.209,20.53A98.706,98.706,0,0,0,27.6,73.734l.959.62.959-.62c1.074-.694,2.142-1.408,3.189-2.132A15.237,15.237,0,0,0,53.814,50.629,23.444,23.444,0,0,0,57.121,39.2ZM28.561,70.141A93.423,93.423,0,0,1,12.768,57.289C6.64,50.849,3.533,44.761,3.533,39.2a13.119,13.119,0,0,1,23.615-7.87l1.412,1.88,1.412-1.88A13.119,13.119,0,0,1,53.588,39.2a19.1,19.1,0,0,1-2.209,8.486,15.236,15.236,0,0,0-21.5,21.576Q29.223,69.7,28.561,70.141Zm12.374.343a11.71,11.71,0,1,1,11.71-11.71A11.724,11.724,0,0,1,40.935,70.484Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7123",
    "data-name": "Path 7123",
    d: "M294.971,268.552h-3.533v5.49h-5.49v3.533h5.49v5.49h3.533v-5.49h5.49v-3.533h-5.49Z",
    transform: "translate(-252.27 -217.035)",
    fill: "#7a7a7a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/Wishlist.490c2d96d1e41485fc7ecd543d006423.svg";
export { ForwardRef as ReactComponent };